import React from "react";

import CheckIcon from "@mui/icons-material/Check";
import styled from "@emotion/styled";

import { checkboxTheme } from "./styles";

const StyledRadioButton = styled.label`
  ${(props) => {
    return checkboxTheme[props.theme];
  }};
`;

const Checkbox = ({
  id,
  name,
  label,
  value,
  checked,
  onChange,
  theme = "primary",
  ...rest
}) => {
  return (
    <StyledRadioButton htmlFor={id} theme={theme}>
      <input
        id={id}
        name={name}
        value={value}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="input"
        {...rest}
      />
      <div className="checkbox-input">
        <div className={`svg-block ${checked ? "svg-checked" : ""}`}>
          {checked && <CheckIcon className="icon" />}
        </div>
      </div>
      {label && <span>{label}</span>}
    </StyledRadioButton>
  );
};

export default Checkbox;
